import ForgotpasswordForm from "@components/login/ForgotPasswordForm";
import BoxPage from "./BoxPage";

export default function ForgotPasswordPage() {
	return (
		<BoxPage>
			<ForgotpasswordForm />
		</BoxPage>
	);
}
